import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";

import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../../../../shared/dialogs/components/message-dialog.component';

import { Observable, BehaviorSubject, ReplaySubject, Subject, combineLatest } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

import { JSR310ConversionService } from '../../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { LocalDate } from '../../../../shared/jsr310-localdates/types/local-date.type';
import { LocalTime } from '../../../../shared/jsr310-localdates/types/local-time.type';
import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';

import { AccesService } from '../services/acces.service';
import { UpdateRappelIntervenantsOrder } from '../entities/update-rappel-intervenants-order.entity';

@Component({
	selector: 'rappel-intervenants',
	templateUrl: 'rappel-intervenants.html',
	// styleUrls: ['rappel-intervenants.css'],
})
export class RappelIntervenantsComponent {
	// Valeurs a binder sur la vue
	accesId!: number;
	popupTitle!: string;
	heure$ = new ReplaySubject<LocalTime>(1);
	date$ = new ReplaySubject<LocalDate | null>(1);

	// Information concatenee pour la saisie de la date/heure de debut
	dateHeure$ = new BehaviorSubject<LocalDateTime | null>(null);
	
	// Gestion globale de la fenetre
	displaySubject: Subject<boolean> = new Subject<boolean>();
	loaded: boolean = false;
	waitingForServer: boolean = false;
		
	constructor( //
		private dialog: MatDialog,
		@Inject(JSR310ConversionService) conversionService: JSR310ConversionService,
		@Inject(AccesService) private accesService: AccesService,
	) {
		// Reconciliation automatique de la date complete
		let dateTime$ = combineLatest([this.date$, this.heure$]).pipe(map(
			([date, heure]) => {
				if (date == null)
					return null;

				return conversionService.merge(date, heure);
			}
		));
		dateTime$.subscribe(
			(date) => this.dateHeure$.next(date)
		);
		
		// Lors de la reception d'une demande d'affichage
		let acces$ = this.displayCommandsSubject.pipe(
			// Recuperation de l'acces
			mergeMap(
				(accesId) => this.accesService.getById(accesId)
			)
		);
		acces$.subscribe(
			// Puis on initialise les donnees avec celle de l'arret
			(acces) => {
				this.accesId = acces.id;
				this.popupTitle = 'Accès ' + acces.numero + ' : Les intervenants ont été rappelés';

				let date = acces.dateRappelIntervenants;
				if (date) {
					// Une date est connue: il faut la reproposer
					this.date$.next([date[0], date[1], date[2]]);
					this.heure$.next([date[3], date[4], date[5]]);
				} else {
					// Pas de date connue: on propose la date/heure du jour
					let dateDebutJS = new Date();
					dateDebutJS.setSeconds(0);
					dateDebutJS.setMilliseconds(0);

					this.date$.next(conversionService.toMandatoryLocalDate(dateDebutJS));
					this.heure$.next(conversionService.toMandatoryLocalTime(dateDebutJS));
				}
				
				this.loaded = true;
				this.displaySubject.next(true);
			}
		);
		
		// Quand on masque la fenetre de dialogue, on nettoie les donnees passees
		this.displaySubject.pipe(
			filter(show => !show)
		).subscribe(
			(_show) => {
				this.loaded = false;
			}
		)
	}
	
	@Input() id = 'rappelIntervenantsDialog';
	
	// Liaison de l'observable servant a commander l'affichage du composant
	private displayCommandsSubject = new SubjectRelay<number>();
	@Input() set displayCommands(obs: Observable<number> | undefined) {
		this.displayCommandsSubject.registerSource(obs);
	}

	// Evenements de validation de l'operation en cours
	@Output() rappelChanged = new EventEmitter<void>();
	
	onCancelRequested() {
		this.displaySubject.next(false);
	}
	
	onYes() {
		this.save(0, this.dateHeure$.getValue());
	}
	
	onNo() {
		this.save(1, null);
	}
	
	onMessage() {
		this.save(2, this.dateHeure$.getValue());
	}
	
	private save(etat: number, date: LocalDateTime | null) {
		let order = {
			accesId: this.accesId,
			etat: etat,
			date: date,
			
		} as UpdateRappelIntervenantsOrder;
		
		this.accesService.updateRappelIntervenants(order).subscribe(
			(_id) => {
				this.waitingForServer = false;
				this.displaySubject.next(false);
				this.rappelChanged.emit();
			},
			(error: HttpErrorResponse) => {
				this.waitingForServer = false;
				this.dialog.open(MessageDialogComponent, {
					width: '400px',
					data: {
						title: "Erreur lors de la modification de l'accès",
						messages: ['Le serveur a rencontré une erreur imprévue']
					}
				});
				console.error("Erreur lors la tentivate de modification de l'accès", error);
			}
		);
		this.displaySubject.next(false);
	}
}